export const META_PIXEL_ID = '1506506424840679'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: Window['fbq']
  }
}

const SCRIPT_ID = 'meta-pixel-script'
const NOSCRIPT_ID = 'meta-pixel-noscript'

/**
 * Loads the official Meta Pixel base code once, then fires the PageView event.
 * Safe to call more than once — the loader and the init/PageView pair are guarded.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return

  if (!window.fbq) {
    const fbq: Window['fbq'] = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args)
      } else {
        fbq.queue?.push(args)
      }
    } as NonNullable<Window['fbq']>

    window.fbq = fbq
    if (!window._fbq) window._fbq = fbq
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []
  }

  if (!document.getElementById(SCRIPT_ID)) {
    const script = document.createElement('script')
    script.id = SCRIPT_ID
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)
  }

  if (!document.getElementById(NOSCRIPT_ID)) {
    const noscript = document.createElement('noscript')
    noscript.id = NOSCRIPT_ID
    const img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.alt = ''
    img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`
    noscript.appendChild(img)
    document.body.appendChild(noscript)
  }

  window.fbq?.('init', META_PIXEL_ID)
  window.fbq?.('track', 'PageView')
}

/** Fires a standard or custom Meta Pixel event, if the pixel has loaded. */
export function trackPixelEvent(
  event: string,
  params?: Record<string, unknown>,
): void {
  window.fbq?.('track', event, params)
}
